// extracted by mini-css-extract-plugin
export var fadeInOut = "_4o-3";
export var icon = "_4o-4";
export var savedIndicator = "_4o-2";
export var savingIndicator = "_4o-0";
export var spin = "_4o-1";